<template>
  <div>
    <b-form-group label="Status da oportunidade">
      <b-form-radio
        v-model="oportunidade.status_exibicao"
        name="status_exibicao"
        value="visivel"
        >Visível</b-form-radio
      >
      <b-form-radio
        v-model="oportunidade.status_exibicao"
        name="status_exibicao"
        value="edicao"
        >Edição</b-form-radio
      >
      <b-form-radio
        v-model="oportunidade.status_exibicao"
        name="status_exibicao"
        value="arquivado"
        >Arquivado</b-form-radio
      >
    </b-form-group>

    <div class="p-4 text-center border">
      <h3>Resumo da oportunidade</h3>
      <resumo-oportunidade-card :oportunidade="oportunidade" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import ResumoOportunidadeCard from "./Resumo/ResumoOportunidadeCard.vue";

export default {
  mixins: [validationMixin],
  components: { ResumoOportunidadeCard },
  name: "Resumo",
  data: () => ({}),

  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    checkFirstOption() {
      this.oportunidade.qualificacao_propostas.includes("emenda-parlamentar")
        ? (this.showModalidadeEmenda = true)
        : (this.showModalidadeEmenda = false);
    },
  },
};
</script>

<style></style>
